"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amplify = void 0;
/*
This file maps top-level exports from `aws-amplify`.
*/
var initSingleton_1 = require("./initSingleton");
Object.defineProperty(exports, "Amplify", { enumerable: true, get: function () { return initSingleton_1.DefaultAmplify; } });
